import { NavBarLinks } from "../types";

export function validatesIfTheResourceHasOnlyOneGroup(
  navBarLinks: NavBarLinks,
  group: string
): boolean {
  if (
    navBarLinks?.[group]?.length === 1 &&
    navBarLinks?.[group][0]?.menuTitle?.toLowerCase() === group?.toLowerCase()
  ) {
    return true;
  }

  return false;
}
